import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Box, Button, Typography } from '@mui/material';
import { Add, Inventory } from '@mui/icons-material';
import { ScreenFrame, ListCard, EmptyState, ViewToggle } from '../PrototypeShared';
import { Inbox } from '@mui/icons-material';

const MOCK_DELIVERIES = [
  { id: '1', supplier: 'Supplier A', lotNumber: 'L2401260', status: 'Approved', date: '2024-03-01' },
  { id: '2', supplier: 'Supplier B', lotNumber: 'L2401261', status: 'Pending', date: '2024-03-02' },
  { id: '3', supplier: 'Supplier C', lotNumber: 'L2401316', status: 'Approved', date: '2024-03-03' },
];

export default function IncomingListScreen() {
  const navigate = useNavigate();
  const [view, setView] = useState('list'); // 'list' | 'empty' | 'error'
  const [filter, setFilter] = useState('all'); // 'all' | 'pending' | 'approved'

  const items = view === 'empty' ? [] : MOCK_DELIVERIES.filter((d) => filter === 'all' || d.status.toLowerCase() === filter);

  return (
    <ScreenFrame
      title="Incoming deliveries"
      actions={
        <>
          <ViewToggle value={view} onChange={setView} options={[{ value: 'list', label: 'With data' }, { value: 'empty', label: 'Empty' }, { value: 'error', label: 'Error' }]} />
          <Button component={Link} to="/prototype/incoming-deliveries/stock" startIcon={<Inventory />} variant="outlined" size="small">
            Stock overview
          </Button>
          <Button component={Link} to="/prototype/receive-goods" startIcon={<Add />} variant="contained" size="small">
            New delivery
          </Button>
        </>
      }
    >
      <Box sx={{ mb: 2, display: 'flex', gap: 1 }}>
        <Button size="small" variant={filter === 'all' ? 'contained' : 'outlined'} onClick={() => setFilter('all')}>All</Button>
        <Button size="small" variant={filter === 'pending' ? 'contained' : 'outlined'} onClick={() => setFilter('pending')}>Pending</Button>
        <Button size="small" variant={filter === 'approved' ? 'contained' : 'outlined'} onClick={() => setFilter('approved')}>Approved</Button>
      </Box>
      {view === 'error' && (
        <Box sx={{ mb: 2 }}>
          <Typography color="error">Failed to load deliveries. <Button size="small" onClick={() => setView('list')}>Retry</Button></Typography>
        </Box>
      )}
      {view === 'empty' && items.length === 0 && (
        <EmptyState icon={Inbox} title="No deliveries" description="No incoming deliveries match your filters or no data yet." actionLabel="New delivery" onAction={() => navigate('/prototype/receive-goods')} />
      )}
      {(view === 'list' && items.length > 0) && (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
          {items.map((d) => (
            <ListCard key={d.id} title={`Delivery ${d.id} — ${d.supplier}`} subtitle={`Lot: ${d.lotNumber} · ${d.date}`} status={d.status} to={`/prototype/incoming-deliveries/${d.id}`} />
          ))}
        </Box>
      )}
    </ScreenFrame>
  );
}
